import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  Row,
  Col,
  Alert,
  Spinner,
  Container
} from "react-bootstrap";
import {
  Paper,
  FormGroup,
  FormControl,
  FormControlLabel,
  Switch
} from "@material-ui/core";

import "../style.css";

import OpenEye from "../../../images/open-eye.png";
import ClosedEye from "../../../images/closed-eye.png";

const API_URL = process.env.REACT_APP_API_URL;

export const AddStaffPage = ({ location }) => {
  const userInfo = JSON.parse(localStorage.getItem("user_info"));
  const businessId = userInfo.business_id;
  const outletId = userInfo.outlet_id;
  const history = useHistory();
  const { allOutlets, allAccessLists, allRoles } = location.state;
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState("");
  const [stateShowPassword, setStateShowPassword] = React.useState(false);
  const [stateShowPassword2, setStateShowPassword2] = React.useState(false);
  const [stateShowPassword3, setStateShowPassword3] = React.useState(false);

  const [selectedPrivileges, setSelectedPrivileges] = React.useState([]);

  // for staff levels
  const [staffLevels, setStaffLevels] = React.useState([]);
  const [hasStaffLevels, setHasStaffLevels] = useState(true);

  const fetchStaffLevels = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/v1/staff-level?business_id=${businessId}&outlet_id=${outletId}`
      );
      setStaffLevels(response.data.data);
      setHasStaffLevels(response.data.data.length > 0);
      console.log("Staff levels fetched:", response.data.data);
    } catch (err) {
      console.error("Error fetching staff levels:", err);
      setHasStaffLevels(false);
    }
  };

  useEffect(() => {
    fetchStaffLevels();
  }, []);

  const initialValueStaff = {
    outlet_id: "",
    type: "Staff",
    role_id: "",
    name: "",
    staff_id: "",
    email: "",
    phone_number: "",
    password: "",
    password_confirmation: "",
    pin: "",
    is_servicer: false,
    staff_level_id: ""
  };
  const StaffSchema = Yup.object().shape({
    outlet_id: Yup.number()
      .integer()
      .min(1)
      .required(`${t("pleaseChooseAnOutlet")}`),
    type: Yup.string()
      .min(3, `${t("minimum3Character")}`)
      .max(50, `${t("maximum50Character")}`)
      .required(`${t("pleaseChooseAType")}`),
    role_id: Yup.number()
      .integer()
      .min(1)
      .required(`${t("pleaseChooseARole")}`),
    name: Yup.string()
      .min(3, `${t("minimum3Character")}`)
      .max(50, `${t("maximum50Character")}`)
      .required(`${t("pleaseInputProductName")}`),
    staff_id: Yup.string()
      .min(5)
      .max(10)
      .required(`${t("pleaseInputStaffID")}`),
    email: Yup.string()
      .email()
      .required(`${t("pleaseInputAnEmail")}`),
    phone_number: Yup.string()
      // .typeError(`${t("pleaseInputANumberOnly")}`)
      .matches(/^\d+$/, `${t("pleaseInputANumberOnly")}`)
      .max(15, `${t("maximum15Character")}`)
      .required(`${t("pleaseInputPhoneNumber")}`),
    password: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!#%*?&`~^]{8,20}$/,
        `${t(
          "passwordAtLeastMustHaveOneLowercase,OneUppercase,OneNumeric,And8CharactersLongMinimum"
        )}`
      )
      .required(`${t("pleaseInputAPassword")}`),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], `${t("passwordDoNotMatch")}`)
      .required(`${t("PleaseInputAPasswordConfirmation")}`),
    pin: Yup.string()
      .matches(/^\d+$/, `${t("pinMustBeNumbers")}`)
      .min(6)
      .max(6)
      .required(`${t("pleaseInputAPin")}`),

    is_servicer: Yup.boolean().required(t("pleaseChooseIsServicer")),
    staff_level_id: Yup.number().when("is_servicer", {
      is: true,
      then: Yup.number().required(t("pleaseSelectStaffLevel"))
    })
  });

  const formikStaff = useFormik({
    enableReinitialize: true,
    initialValues: initialValueStaff,
    validationSchema: StaffSchema,
    onSubmit: async (values) => {
      const API_URL = process.env.REACT_APP_API_URL;

      console.log("Form submitted with values:", values);
      console.log("Form errors:", formikStaff.errors);

      const staffData = {
        name: values.name,
        staff_id: values.staff_id,
        email: values.email,
        password: values.password,
        pin: values.pin,
        phone_number: values.phone_number,
        type: values.type,
        role_id: values.role_id,
        outlet_id: values.outlet_id,
        is_servicer: values.is_servicer,
        staff_level_id: values.is_servicer ? values.staff_level_id : null
      };

      try {
        enableLoading();
        await axios.post(`${API_URL}/api/v1/staff`, staffData);
        disableLoading();
        history.push("/staff");
      } catch (err) {
        console.error(err.response.data.message);
        setAlert(err.response?.data.message);
        disableLoading();
      }
    }
  });

  const validationStaff = (fieldname) => {
    if (formikStaff.touched[fieldname] && formikStaff.errors[fieldname]) {
      return "is-invalid";
    }

    if (formikStaff.touched[fieldname] && !formikStaff.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const enableLoading = () => setLoading(true);
  const disableLoading = () => setLoading(false);

  const camelize = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  };

  const handleChangeServicer = (e) => {
    const isServicer = e.target.value === "true";
    if (isServicer && !hasStaffLevels) {
      // Prevent changing to "Yes" if there are no staff levels
      return;
    }
    formikStaff.setFieldValue("is_servicer", isServicer);
    if (!isServicer) {
      formikStaff.setFieldValue("staff_level_id", "");
    }
  };

  const handleChangeRole = (e) => {
    const { name, value } = e.target;

    if (!value) {
      return;
    }

    const selectedId = parseInt(value);
    formikStaff.setFieldValue(name, selectedId);

    const selectedRole = allRoles.find((item) => item.id === selectedId);

    const sortedPrivileges = selectedRole.Role_Privileges.sort(
      (a, b) => a.privilege_id - b.privilege_id
    );

    sortedPrivileges.map((value) => {
      value.Privilege.name = camelize(value.Privilege.name);
    });

    // handle hide commisison management
    sortedPrivileges.map((value, index) => {
      if (value.name === "commissionManagement") {
        delete sortedPrivileges[index];
      }
    });

    setSelectedPrivileges(sortedPrivileges);
  };

  const showPassword = () => {
    setStateShowPassword(!stateShowPassword);
    console.log("hellow brow");
    const password = document.getElementById("show");
    if (password.type === "password") {
      password.type = "text";
    } else {
      password.type = "password";
    }
  };

  const showPassword2 = () => {
    setStateShowPassword2(!stateShowPassword2);
    console.log("hellow brow");
    const password = document.getElementById("show2");
    if (password.type === "password") {
      password.type = "text";
    } else {
      password.type = "password";
    }
  };

  const showPassword3 = () => {
    setStateShowPassword3(!stateShowPassword3);
    console.log("hellow brow");
    const password = document.getElementById("show3");
    if (password.type === "password") {
      password.type = "text";
    } else {
      password.type = "password";
    }
  };

  useEffect(() => {
    if (Object.keys(formikStaff.errors).length > 0) {
      console.log("Form errors:", formikStaff.errors);
    }
  }, [formikStaff.errors]);

  useEffect(() => {
    console.log("Form values:", formikStaff.values);
  }, [formikStaff.values]);

  return (
    <>
      <Row>
        <Col>
          <Paper elevation={2} style={{ padding: "1rem", height: "100%" }}>
            <Form onSubmit={formikStaff.handleSubmit}>
              <div className="headerPage">
                <div className="headerStart">
                  <h3>{t("addStaff")}</h3>
                </div>
                <div className="headerEnd">
                  <Link to="/staff">
                    <Button variant="secondary">{t("cancel")}</Button>
                  </Link>
                  <Button
                    variant="primary"
                    style={{ marginLeft: "0.5rem" }}
                    type="submit"
                  >
                    {t("save")}
                    {loading && (
                      <Spinner animation="border" variant="light" size="sm" />
                    )}
                  </Button>
                  {/* {Object.keys(formikStaff.errors).length > 0 && (
                    <div className="fv-plugins-message-container mt-2">
                      <div className="fv-help-block">
                        {t("pleaseCheckAllRequiredFields")}
                        <ul>
                          {Object.entries(formikStaff.errors).map(
                            ([field, error]) => (
                              <li key={field}>{`${field}: ${error}`}</li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
              {alert ? (
                <Row>
                  <Col>
                    <Alert variant="danger">{alert}</Alert>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              <Row style={{ padding: "1rem" }}>
                <Col>
                  <Form.Group>
                    <Form.Label>{t("outlet")}*</Form.Label>
                    <Form.Control
                      as="select"
                      name="outlet_id"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("outlet_id")}
                      className={validationStaff("outlet_id")}
                      required
                    >
                      <option value={""} disabled hidden>
                        {t("chooseOutlet")}
                      </option>
                      {allOutlets.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {formikStaff.touched.outlet_id &&
                    formikStaff.errors.outlet_id ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.outlet_id}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  {/* <Form.Group>
                    <Form.Label>Type*</Form.Label>
                    <Form.Control
                      as="select"
                      name="type"
                      {...formikStaff.getFieldProps("type")}
                      className={validationStaff("type")}
                      required
                    >
                      <option value={""} disabled hidden>
                        Choose Type
                      </option>
                      {["Kasir", "Waiter", "Staff", "Manager"].map(
                        (item, index) => {
                          return (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          );
                        }
                      )}
                    </Form.Control>
                    {formikStaff.touched.type && formikStaff.errors.type ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.type}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group> */}

                  <Form.Group>
                    <Form.Label>{t("role")}*</Form.Label>
                    <Form.Control
                      as="select"
                      name="role_id"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("role_id")}
                      onChange={handleChangeRole}
                      onBlur={handleChangeRole}
                      className={validationStaff("role_id")}
                      required
                    >
                      <option value={""} disabled hidden>
                        {t("chooseRole")}
                      </option>
                      {allRoles.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {formikStaff.touched.role_id &&
                    formikStaff.errors.role_id ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.role_id}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>{t("name")}*</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("name")}
                      className={validationStaff("name")}
                      required
                    />
                    {formikStaff.touched.name && formikStaff.errors.name ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.name}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>{t("staffID")}*</Form.Label>
                    <Form.Control
                      type="text"
                      name="staff_id"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("staff_id")}
                      className={validationStaff("staff_id")}
                      required
                    />
                    {formikStaff.touched.staff_id &&
                    formikStaff.errors.staff_id ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.staff_id}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>{t("Servicer")} (optional)</Form.Label>
                    <Form.Control
                      as="select"
                      name="is_servicer"
                      value={
                        formikStaff.values.is_servicer === true
                          ? "true"
                          : "false"
                      }
                      onChange={handleChangeServicer}
                      onBlur={formikStaff.handleBlur}
                      className={validationStaff("is_servicer")}
                      required
                      disabled={!hasStaffLevels}
                    >
                      <option value="" disabled>
                        {t("chooseIsServicer")}
                      </option>
                      <option value="false">{t("no")}</option>
                      <option value="true">{t("yes")}</option>
                    </Form.Control>
                    {!hasStaffLevels && (
                      <div className="text-danger mt-2">
                        {t("pleaseAddStaffLevelFirstBeforeActivateServicer")}
                      </div>
                    )}
                    {formikStaff.touched.is_servicer &&
                    formikStaff.errors.is_servicer ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.is_servicer}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  {formikStaff.values.is_servicer === true && (
                    <Form.Group>
                      <Form.Label>{t("staffLevel")}*</Form.Label>
                      <Form.Control
                        as="select"
                        name="staff_level_id"
                        value={formikStaff.values.staff_level_id || ""}
                        onChange={formikStaff.handleChange}
                        onBlur={formikStaff.handleBlur}
                        className={validationStaff("staff_level_id")}
                        required
                      >
                        <option value="">{t("chooseStaffLevel")}</option>
                        {staffLevels.map((level) => (
                          <option key={level.id} value={level.id.toString()}>
                            {level.name}
                          </option>
                        ))}
                      </Form.Control>
                      {formikStaff.touched.staff_level_id &&
                      formikStaff.errors.staff_level_id ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formikStaff.errors.staff_level_id}
                          </div>
                        </div>
                      ) : null}
                    </Form.Group>
                  )}

                  <Form.Group>
                    <Form.Label>{t("email")}*</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("email")}
                      className={validationStaff("email")}
                      required
                    />
                    {formikStaff.touched.email && formikStaff.errors.email ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.email}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>{t("phoneNumber")}*</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone_number"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("phone_number")}
                      className={validationStaff("phone_number")}
                      required
                    />
                    {formikStaff.touched.phone_number &&
                    formikStaff.errors.phone_number ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.phone_number}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="container-form-password">
                    <Form.Label>{t("password")}*</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("password")}
                      className={validationStaff("password")}
                      required
                      id="show"
                    />
                    <div
                      className="wrapper-icon-password-staff"
                      onClick={() => showPassword()}
                    >
                      {stateShowPassword ? (
                        <img src={OpenEye} alt="Open-eye" />
                      ) : (
                        <img src={ClosedEye} alt="Closed-eye" />
                      )}
                    </div>
                    {formikStaff.touched.password &&
                    formikStaff.errors.password ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.password}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="container-form-password">
                    <Form.Label>{t("passwordConfirmation")}*</Form.Label>
                    <Form.Control
                      type="password"
                      name="password_confirmation"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("password_confirmation")}
                      className={validationStaff("password_confirmation")}
                      required
                      id="show2"
                    />
                    <div
                      className="wrapper-icon-password-staff"
                      onClick={() => showPassword2()}
                    >
                      {stateShowPassword2 ? (
                        <img src={OpenEye} alt="Open-eye" />
                      ) : (
                        <img src={ClosedEye} alt="Closed-eye" />
                      )}
                    </div>
                    {formikStaff.touched.password_confirmation &&
                    formikStaff.errors.password_confirmation ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.password_confirmation}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="container-form-password">
                    <Form.Label>{t("pin")}*</Form.Label>
                    <Form.Control
                      type="password"
                      name="pin"
                      autoComplete="new-password"
                      {...formikStaff.getFieldProps("pin")}
                      className={validationStaff("pin")}
                      required
                      id="show3"
                    />
                    <div
                      className="wrapper-icon-password-staff"
                      onClick={() => showPassword3()}
                    >
                      {stateShowPassword3 ? (
                        <img src={OpenEye} alt="Open-eye" />
                      ) : (
                        <img src={ClosedEye} alt="Closed-eye" />
                      )}
                    </div>
                    {formikStaff.touched.pin && formikStaff.errors.pin ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formikStaff.errors.pin}
                        </div>
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Paper>
        </Col>

        <Col>
          <Row>
            {selectedPrivileges.length
              ? allAccessLists.map((access) => {
                  return (
                    <Col key={access.id}>
                      <Paper
                        elevation={2}
                        style={{ padding: "1rem", height: "100%" }}
                      >
                        <h5>
                          {access.name === "Cashier" ? "Frontend" : access.name}{" "}
                          {t("accessList")}
                        </h5>

                        <FormControl
                          component="fieldset"
                          style={{ width: "100%" }}
                        >
                          <FormGroup row>
                            <Container style={{ padding: "0" }}>
                              {selectedPrivileges.map((privilege, index) => {
                                if (
                                  access.name ===
                                  privilege.Privilege.Access.name
                                ) {
                                  return (
                                    <Row
                                      key={index}
                                      style={{ padding: "0.5rem 1rem" }}
                                    >
                                      <Col style={{ alignSelf: "center" }}>
                                        <Form.Label>
                                          {privilege.Privilege.name ===
                                          "changingTransaction"
                                            ? `${t("deleteTransaction")}`
                                            : `${t(privilege.Privilege.name)}`}
                                        </Form.Label>
                                      </Col>
                                      <Col style={{ textAlign: "end" }}>
                                        <FormControlLabel
                                          key={privilege.Privilege.id}
                                          control={
                                            <Switch
                                              key={privilege.Privilege.id}
                                              value={privilege.Privilege.name}
                                              color="primary"
                                              checked={privilege.allow}
                                              style={{
                                                cursor: "not-allowed"
                                              }}
                                            />
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  );
                                } else {
                                  return "";
                                }
                              })}
                            </Container>
                          </FormGroup>
                        </FormControl>
                      </Paper>
                    </Col>
                  );
                })
              : ""}
          </Row>
        </Col>
      </Row>
    </>
  );
};